<template>
	<el-button type="text" @click="jump">{{ scope.row[tableData.bind] }}</el-button>
</template>

<script>
export default {
	name: 'detailBtn',
	props: {
		tableData: Object,
		scope: Object,
	},
	methods: {
		jump() {
			let url = '/kit/articleAssistant/';
			this.$router.push({
				path: url,
				query: {
					id: this.scope.row.seoSiteId,
					name: this.scope.row.name,
				},
			});
		},
	},
};
</script>

<style scoped></style>
